import { Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

/** The footprint of the small IconButton this replaces, so no row shifts. */
const MARKER_SIZE = 30;

type Props = {
  isSelected: boolean;
};

/**
 * The radio-style mark on a selectable person row. Deliberately NOT a control: it renders inside
 * the row's own trigger (SocialUserRow's `marker` slot), so the whole row — mark included — is the
 * single thing you click, and the mark can never swallow that click or offer a second target for
 * the same action. The row reports the state to assistive tech via aria-pressed, hence aria-hidden
 * here.
 */
export const ChatSelectionMarker = ({ isSelected }: Props) => (
  <Box
    aria-hidden
    display="flex"
    alignItems="center"
    justifyContent="center"
    width={MARKER_SIZE}
    height={MARKER_SIZE}
    flexShrink={0}
  >
    {isSelected ? (
      <CheckCircleIcon color="primary" fontSize="small" />
    ) : (
      // The empty half of the pair: without it a selectable row looks like a link, and nothing
      // says the filled circle is a state you can put a row into.
      <RadioButtonUncheckedIcon color="disabled" fontSize="small" />
    )}
  </Box>
);
